import { projectRequest } from 'store/utils/request';

const FIVE_MINUTES_IN_MILLISEC = 5 * 60 * 1000;

export const partialExport = (path, ids, key = 'id__in') =>
  projectRequest.post(`/${path}/export/`, null, {
    params: ids ? { [key]: ids.join() } : null,
    requestId: `export-${path}`,
    responseType: 'blob',
    timeout: FIVE_MINUTES_IN_MILLISEC,
  });

export const cancelExport = path => projectRequest.cancel(`export-${path}`);

export const partialImport = type => {
  // TODO: change to actual paths
  const typePath = type === 'merge' ? 'import' : 'replace';

  return (path, file) => {
    const formData = new FormData();
    formData.append('zip_file', file, file.name);

    return projectRequest.post(`/${path}/${typePath}/`, formData, {
      headers: {
        'Content-Type': `multipart/form-data; boundary=${formData._boundary}`,
      },
      requestId: `import-and-${type}-${path}`,
      timeout: FIVE_MINUTES_IN_MILLISEC,
    });
  };
};

export const partialImportAndMerge = partialImport('merge');
export const partialImportAndReplace = partialImport('replace');
